import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';

export const NotifyDialog = styled.div`
  width: 100%;
`;

export const Inner = styled.div`
  text-align: center;
  width: 300px;
  max-width: 100%;
  margin: 0 auto;

  ${breakpoint('medium')} {
    width: 350px;
  }
`;

export default {};
